import BeaconAction from '@tencent/beacon-web-sdk';
import { getGuid } from './getGuid';
import { getBrowserInfo } from './getBrowserInfo';
import { getWebUid } from './getWebUids';


let beaconAction: BeaconAction | null = null;
const appKey = '0WEB06FB3Y7OLHBA'; // 翻译君官网appkey

/**
 * 初始化灯塔实例
 */
export const initBeaconSDK = () => {
  if (beaconAction) {
    return;
  }
  beaconAction = new BeaconAction({
    appkey: appKey,
  });
};

/**
 * 获取公参
 */
export const getCommonParams = (eventName: string) => {
  const { osVersion, language } = getBrowserInfo();
  const webUid = sessionStorage.getItem('web_uid') || getWebUid();
  const reportParams = {
    instance_id: 5,
    // 事件发生时间，秒时间戳
    event_time: Math.floor(new Date().getTime() / 1000),
    // 事件发生时间，毫秒时间戳
    event_time_ms: new Date().getTime(),
    unique_report_id: getGuid(),
    // 以下4个参数和产品确认过需要上报公参，公共的错误
    result_code: 0,
    event_code: eventName,
    error_code: '',
    error_msg: '',
    web_uid: `web_${webUid}`,
    product: 'translator',
    os_version: osVersion,
    // 官网无需登录，游客态上报0
    user_status: '0',
    // 以下是web端拿不到的公参，产品要求也上报，值为空
    uid: '',
    device_id: '',
    server_ip: '',
    client_ip: '',
    server_time: '',
    qimei_36: '',
    version: '',
    channel: '',
    app_publish_channel: '',
    manufacture: '',
    machine: '',
    rom_name: '',
    language,
    country: '',
    province: '',
    city: '',
    client_ipv6: '',
    session_id: '',
  };
  return {
    ...reportParams,
  }
}

/**
 * 上报方法
 * @param eventCode
 * @param reportData
 */
export const doBeaconReport = (eventCode: string, reportData?: any) => {
  initBeaconSDK();

  beaconAction?.onDirectUserAction(eventCode, {
    ...getCommonParams(eventCode),
    ...reportData,
  });
}